import * as a from 'actions/countries';

const initial = {
  data: [],
  error: null,
};

const countries = (state = initial, action = null) => {
  switch (action.type) {
    case a.SET_COUNTRIES:
      return {
        ...state,
        data: action.countries,
        error: null,
      };
    case a.SET_COUNTRIES_ERROR:
      return {
        ...state,
        error: action.error,
        data: null,
      };
    default:
      return state;
  }
};

export default countries;
